import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import type {IconDefinition} from '@fortawesome/fontawesome-svg-core';

type Props = {
    icon: IconDefinition;
    label: string;
    value: string | number;
    sublabel?: string;
    color?: string;
    loading?: boolean;
};

/** Matches ModernDashboard.css's .uz-stat-card markup exactly, as a reusable
 * component instead of every dashboard hand-rolling the same divs. */
const StatTile: React.FC<Props> = ({icon, label, value, sublabel, color = '#0ab39c', loading}) => (
    <div className="uz-stat-card d-flex align-items-center gap-3">
        <div className="uz-stat-icon" style={{backgroundColor: `${color}1f`, color}}>
            <FontAwesomeIcon icon={icon}/>
        </div>
        <div>
            {loading ? (
                <div className="uz-skeleton" style={{width: 60, height: 24}}/>
            ) : (
                <div className="uz-stat-value">{value}</div>
            )}
            <div className="uz-stat-label">{label}</div>
            {sublabel && <div className="uz-stat-sub">{sublabel}</div>}
        </div>
    </div>
);

export default StatTile;
